import React from "react";
import { SourceData } from "@shared/types/reporting";
import { XAxis, YAxis, CartesianGrid, Legend, BarChart, Bar, Label, ResponsiveContainer } from "recharts";
import theme from "@ats/styles/theme";
import { useColorSchemeContext } from "@shared/context/ColorSchemeContext";

interface JobMetricsSourceChartProps {
  sourceData: SourceData;
}

const yTickFormatter = (value: string, index: number) => {
  const limit = 16; // put your maximum character
  if (!value) return value;
  if (value.length <= limit) return value;
  return `${value.substring(0, limit)}...`;
};

const legendFormatter = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

function JobMetricsSourceChart(props: JobMetricsSourceChartProps) {
  const { sourceData } = props;
  const { isDarkMode } = useColorSchemeContext();

  const data = !sourceData
    ? []
    : Object.entries(sourceData)
        .sort((a: any, b: any) => b[1].total - a[1].total)
        .map(([key, value]: [string, any]) => {
          return {
            source: key ? key : "No Source",
            total: value.total,
            hired: value.hired,
          };
        });

  return (
    <ResponsiveContainer width="100%" height={data.length * (24 + 20) + 48}>
      <BarChart
        data={data}
        layout="vertical"
        barSize={12}
        barGap={0}
        barCategoryGap={10}
        margin={{ top: -40, right: 6, bottom: 0, left: 0 }}
      >
        <CartesianGrid
          strokeDasharray="3 3"
          horizontal={false}
          stroke={isDarkMode ? theme.color.gray[600] : theme.color.gray[200]}
        />
        <Bar dataKey="total" fill={isDarkMode ? theme.color.gray[300] : theme.color.black} />
        <Bar dataKey="hired" fill={isDarkMode ? theme.color.gray[500] : theme.color.gray[500]} />
        <XAxis
          type="number"
          height={48}
          tickMargin={6}
          tick={{ fill: isDarkMode ? theme.color.gray[400] : theme.color.gray[600] }}
        >
          <Label
            value="Number of candidates"
            position="insideBottom"
            fill={isDarkMode ? theme.color.gray[400] : theme.color.gray[600]}
          />
        </XAxis>
        <YAxis
          tickFormatter={yTickFormatter}
          width={120}
          type="category"
          dataKey="source"
          tickMargin={6}
          tick={{ fill: isDarkMode ? theme.color.gray[400] : theme.color.gray[600] }}
        />
        <Legend
          formatter={legendFormatter}
          iconType="square"
          align="right"
          verticalAlign="top"
          height={40}
          iconSize={10}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}

export default JobMetricsSourceChart;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};
